// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "ABSENCE_RATE_PERCENTAGE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      absenceRatePercentage: {
        required: findSchemaRequired(typeSchema, "absenceRatePercentage"),
        title: "Absence Rate Percentage",
        properties: {
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
          absenceRate: {
            type: "number",
            title: "Percentage",
          },
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "absenceRatePercentage"],
  };
};

export const uiSchema = (t: (s: string) => string) => baseUiSchema(t);

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
